import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { ErrorBanner } from "../components/ErrorBanner";
import { SearchInput } from "../components/SearchInput";
import { useCatalog } from "../context/CatalogContext";
import { matchesQuery } from "../api/format";

export function StationsList() {
  const { stations, loading, error, reload } = useCatalog();
  const [q, setQ] = useState("");
  const rows = useMemo(
    () => stations.filter((s) => matchesQuery(q, s.station_name, s.station_name_ur, s.city, s.station_id)),
    [stations, q],
  );

  return (
    <div className="page">
      <div className="page-head">
        <h1>Stations</h1>
        <SearchInput value={q} onChange={setQ} placeholder="Search name, city, Urdu…" />
      </div>
      <ErrorBanner error={error} onRetry={reload} />
      {loading ? <p className="muted">Loading stations…</p> : null}
      {!loading && rows.length === 0 ? <p className="muted">No stations.</p> : null}
      {rows.length > 0 ? (
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>City</th>
                <th>Urdu</th>
                <th>Active</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((s) => (
                <tr key={s.station_id}>
                  <td>
                    <Link to={`/stations/${s.station_id}`}>{s.station_name}</Link>
                  </td>
                  <td>{s.city || "—"}</td>
                  <td className="urdu">{s.station_name_ur || "—"}</td>
                  <td>{s.is_active ? "yes" : "no"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
}
